import { z } from "zod";

const nextServerEnvSchema = z.object({
  GATEWAY_HOSTPORT: z.string().optional(),
  GATEWAY_PROTOCOL: z.string().optional(),
  CORE_API_URL: z.string().optional(),
  SENTRY_NEXT_BE_DSN: z.string().optional(),
  SENTRY_NEXT_BE_PROJECT_NAME: z.string().optional(),
  SENTRY_NEXT_FE_PROJECT_NAME: z.string().optional(),
  RENDER_GIT_COMMIT: z.string().optional(),
  CI: z.string().optional(),
  SENTRY_AUTH_TOKEN: z.string().optional(),
  STANDALONE_BUILD: z.string().optional(),
  PORT: z.string().optional(),
});

export type NextServerEnv = z.infer<typeof nextServerEnvSchema>;

export const nextServerEnv: NextServerEnv = nextServerEnvSchema.parse(
  process.env,
);
